import NotFound from 'components/NotFound';
import lazyWithRetry from 'services/lazyWithRetry';
import { Features, Roles } from 'typings/enums';
import { RouteCollection } from 'typings/shared';

const basePath = '/credit-note';

const ShowPage = lazyWithRetry(() => import('./Show'));

export const paths = {
    LIST: basePath,
    ADD: `${basePath}/add`,
    SHOW: `${basePath}/:id/show`,
    EDIT: `${basePath}/:id/edit`,
};

export const routes: RouteCollection = {
    list: {
        exact: true,
        path: paths.LIST,
        component: NotFound,
        roles: [Roles.TRADER],
        features: [Features.RENTAL_AGENCY],
    },
    add: {
        exact: true,
        path: paths.ADD,
        component: NotFound,
        roles: [Roles.TRADER],
        features: [Features.RENTAL_AGENCY],
    },
    edit: {
        exact: true,
        path: paths.EDIT,
        component: NotFound,
        roles: [Roles.TRADER],
        features: [Features.RENTAL_AGENCY],
    },
    show: {
        exact: true,
        path: paths.SHOW,
        component: ShowPage,
        roles: [Roles.TRADER],
        features: [Features.RENTAL_AGENCY],
    },
};
